export default __webpack_public_path__ + "static/knowledge-hub-header-bg-d03ff490d423b20d8c0dc7293e6bc9c8.jpg";